import adminApiClient from './apiClient.js';

export const nfceApi = {
  listHomologacaoConfig: async () => {
    const { data } = await adminApiClient.get('/nfce/homologacao-config');
    return data;
  },
  createHomologacaoConfig: async (payload) => {
    const { data } = await adminApiClient.post('/nfce/homologacao-config', payload);
    return data;
  },
  updateHomologacaoConfig: async (id, payload) => {
    const { data } = await adminApiClient.put(`/nfce/homologacao-config/${id}`, payload);
    return data;
  },
  getInsights: async (dias = 30) => {
    const { data } = await adminApiClient.get('/nfce/insights', { params: { dias } });
    return data;
  },
};

export default nfceApi;
